import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { DocumentDataStore } from '../document-data/document-data.store';
import { CreditMemo } from './credit-memo.model';
import { IState, selectFeature } from './credit-memo-data.reducer';

@Injectable()
export class CreditMemoDataStore extends DocumentDataStore<IState, CreditMemo> {
  constructor(store: Store<any>) {
    super(store, selectFeature);
  }
}
